import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { BreakpointObserverService } from './breakpoint-observer/breakpoint-observer.service';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private breakpointObserver = inject(BreakpointObserverService);

  // Signals
  public opened = signal<boolean>(true);
  public showGlobalToggle = signal<boolean>(true);
  public isSmallScreen = this.breakpointObserver.isSmallScreen;
  public isTabletScreen = this.breakpointObserver.isTabletScreen;
  public isSmallOrTablet = computed(() => this.isSmallScreen() || this.isTabletScreen());
  public mode = computed(() => (this.isSmallOrTablet() ? 'over' : 'side'));

  constructor() {
    effect(() => {
      const isSmallOrTablet = this.isSmallOrTablet();
      // Automatically close on mobile/tablet portrait, open on desktop
      this.opened.set(!isSmallOrTablet);
    });
  }

  toggle() {
    this.opened.update((v) => !v);
  }

  close() {
    this.opened.set(false);
  }

  open() {
    this.opened.set(true);
  }
}
